module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "publisheri"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/title.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("ONE MOTHER’S DESPERATE QUEST")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('i', [_vm._v("to Uncover What Was Really Wrong with Her Family..."), _c('br'), _vm._v("and")]), _vm._v(" THE DISTURBING FACTS "), _c('i', [_vm._v("She Revealed that Could")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle2"
  }, [_c('b', [_vm._v("HELP SAVE YOURS")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("ELIZABETH HARRIS")]), _vm._v(" "), _c('p', {
    staticClass: "publisheri"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("NEW YORK")]), _vm._v(" "), _c('p', {
    staticClass: "publishers"
  }, [_vm._v("LONDON • NASHVILLE • MELBOURNE • VANCOUVER")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e160e06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 66
// module chunks = 0